














import { Vue, Component, Prop } from 'nuxt-property-decorator'
import {
  computed,
  defineComponent,
  SetupContext,
} from '@nuxtjs/composition-api'
import BlockText from '@/components/BlockText.vue'
import BlockForms from '@/components/BlockForms.vue'

@Component
class BlockFeedback extends Vue {
  @Prop() readonly message: String = ''
  @Prop() readonly errorMessage: String = ''
  @Prop() readonly buttonText: String = ''
  @Prop() readonly lang: String = ''
  @Prop() readonly isSuccess: Boolean = true
  static options: any
}

export default defineComponent({
  name: 'BlockFeedback',
  components: {
    BlockForms,
    BlockText,
  },
  props: BlockFeedback.options.props,
  setup(_props: any, { emit, root }: SetupContext) {
    const textFailedForm = computed(
      () => root.$store.getters['settings/textFailedForm']
    )
    const onClick = () => {
      emit('click-form')
    }
    return {
      onClick,
      textFailedForm,
    }
  },
})
